import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import './SidebarMenu.scss';
import PropTypes from 'prop-types';
import icConfig from '../../../images/ic_config.png';
import icLogout from '../../../images/ic_logout.png';
import actions from '../../../redux/actions';
import {useHistory} from 'react-router-dom';
import {Tooltip} from '@mui/material';
import Ebutton from '../Ebutton/Ebutton';

const adminOptions = [
    // {name: 'Inicio', route: '/home'},
    {name: 'Usuarios de Prestadores', route: '/v1/provider/list'},
    {name: 'Administradores', route: '/v1/admin/list'},
    {name: 'Historial atenciones', route: '/v1/attentionsList'},
    {name: 'Nueva atención', route: '/v1/newMedicalService',
    description: 'Registrar nuevas prestaciones.', component: (data) => tooltip(data)},
    {name: 'Cobertura', route: '/v1/plans/list',
    description: 'Información acerca de la cobertura de nuestros planes.', component: (data) => tooltip(data)},
    {name: 'Consulta de afiliados', route: '/v1/affiliates',
    description: 'Verificación de estado y cobertura del afiliado.', component: (data) => tooltip(data)},
    {name: 'Grilla de valores', route: '/v1/amount/list'},
    {name: 'Performance', route: '/performance', description: 'Test API performance and measure response times.'},
];

const providerUserOptions = [
    // {name: 'Inicio', route: '/home'},
    // {name: 'Historial atenciones', route: '/attentionsList'},
    // {name: 'Atenciones', route: '/newMedicalService'},
    // {name: 'Planes', route: '/plans/list'},
    {name: 'Afiliados', route: '/v1/affiliates',
    description: 'Verificación de estado y cobertura del afiliado.', component: (data) => tooltip(data)},
];

const providerUserOptionsFf = [
    // {name: 'Inicio', route: '/home'},
    {name: 'Historial atenciones', route: '/v1/attentionsList'},
    {name: 'Nueva atención', route: '/v1/newMedicalService',
    description: 'Registrar nuevas prestaciones.', component: (data) => tooltip(data)},
    {name: 'Cobertura', route: '/v1/plans/list',
    description: 'Información acerca de la cobertura de nuestros planes', component: (data) => tooltip(data)},
    {name: 'Consulta de afiliados', route: '/v1/affiliates',
    description: 'Verificación de estado y cobertura del afiliado.', component: (data) => tooltip(data)},
];

// deberia ver los prestadores de su sede
const providerAdminOptions = [
    // {name: 'Inicio', route: '/home'},
/*    {name: 'Usuarios de Prestadores', route: '/provider/list'},*/
    // {name: 'Historial atenciones', route: '/attentionsList'},
    // {name: 'Atenciones', route: '/newMedicalService'},
    // {name: 'Planes', route: '/plans/list'},
    {name: 'Afiliados', route: '/affiliates', description: 'Verificación de estado y cobertura del afiliado.', component: (data) => tooltip(data)},
];

const providerAdminOptionsFf = [
    // {name: 'Inicio', route: '/home'},
/*    {name: 'Usuarios de Prestadores', route: '/provider/list'},*/
    {name: 'Historial atenciones', route: '/v1/attentionsList'},
    {name: 'Nueva atención', route: '/v1/newMedicalService',
    description: 'Registrar nuevas prestaciones.', component: (data) => tooltip(data)},
    {name: 'Cobertura', route: '/v1/plans/list',
    description: 'Información acerca de la cobertura de nuestros planes', component: (data) => tooltip(data)},
    {name: 'Consulta de afiliados', route: '/v1/affiliates',
    description: 'Verificación de estado y cobertura del afiliado.', component: (data) => tooltip(data)},
    {name: 'Grilla de valores', route: '/v1/amount/list'},

];

const tooltip = (item) => {
    return (
        <Tooltip title={item.description}>
            <text>{item.name}</text>
        </Tooltip>
    );
};


const SidebarMenu = (props) => {
    const {
        content,
        title,
        switchOfUser,
        logout,
        userInfo,
        showSidebar,
        featureFlag,
    } = props;
    const [options, setOptions] = useState([]);
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        content && setOptions(content);
        switch (userInfo.role.name) {
            case 'ADMIN':
                setOptions(adminOptions);
                break;
            case 'PROVIDER_ADMIN':
                setOptions(providerAdminOptionsFf);
                break;
            case 'PROVIDER_USER':
                setOptions(providerUserOptionsFf);
                break;
            default:
                setOptions(providerUserOptions);
                break;
        }
        // eslint-disable-next-line
    }, [content]);

    const pushPage = (name, route) => {
        switchOfUser(name);
        history.push(route);
    };

    return showSidebar ? (
        <div className="sb-div-background">
            <div className={'sb-options-container'}>

                <div className="sb-div-options">
                    {
                        options && options.map((item, index) => {
                            return <button
                                className={`sb-btn-option ${title && title === item.name && 'sb-active'}`}
                                key={index}
                                onClick={() => {
                                    if (showSidebar && window.innerWidth <= 700) dispatch(actions.common.toggleSideBar());
                                    pushPage(item.name, item.route);
                                }}>
                                { item?.component ? item.component(item): item.name }
                            </button>;
                        })

                    }
                </div>
            </div>
            <div className="sb-div-bottom">
                <>
                    <div className="sb-div-bottom">
                        <button onClick={() => {
                            history.push('/config');
                        }}><img src={icConfig} alt={'Config'}/></button>
                        <button onClick={() => {
                            history.replace('/login');
                            logout();
                        }}><img src={icLogout} alt={'Logout'}/></button>
                    </div>
                </>
            </div>
        </div>
    ) : null;
};

const mapStateToProps = (state) => ({
    title: state.home.title,
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
    featureFlag: state.home.setSelfState.featureFlag,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    logout: () => dispatch(actions.login.logout()),
});

SidebarMenu.propTypes = {
    content: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenu);

